import React, { useState } from 'react';
import { Col, Row, Form } from 'reactstrap';
import { DateRangePicker } from 'rsuite';
import axios from 'axios';

function QueueExportReport(props) {
    const { users, type, exportType } = props;
    const [dateRange, setDateRange] = useState(null);
    const [loading, setLoading] = useState(false);
    const omsServiceapiUrl = process.env.REACT_APP_OMS_NEST_API;

    const handleExport = async (e) => {
        e.preventDefault();

        if (!dateRange || dateRange.length !== 2) {
            alert("Please select a date range before exporting.");
            return;
        }

        const [dateFrom, dateTo] = dateRange.map(date => date.toISOString().split('T')[0]);

        const payload = {
            exportType,
            dateFrom,
            dateTo,
            country: "ae",
            status: "all",
            userId: users.user_id,
            email: users.user_email,
            name: users.user_name,
            type
        };

        setLoading(true);

        try {
            const response = await axios.post(`${omsServiceapiUrl}/automation/cancel-report`, payload, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.status === 201 && response.data.status === "success") {
                alert(response.data.message); // "Report has been sent to user"
            } else {
                alert("Export failed. Please try again.");
            }
        } catch (error) {
            console.error("Error exporting report:", error);
            alert("An error occurred while exporting.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row className="align-items-end justify-content-end">
            <Form onSubmit={handleExport}>
                <Col xl={12} className="text-end">
                    <div className="DashbordFliter">
                        <div className="InputBg">
                            <DateRangePicker
                                placement="leftStart"
                                placeholder="Select Date Range"
                                onChange={setDateRange}
                                value={dateRange}
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-dark d-flex align-items-center"
                            disabled={loading}
                        >
                            {loading ? "Exporting..." : "Export"}
                            <i className="bx bx-download ms-2"></i>
                        </button>
                    </div>
                </Col>
            </Form>
        </Row>
    );
}

export default QueueExportReport;
